import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../Univ.js";

function PharmVendorQuoteList() {
    const [quotationData, setQuotationData] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        fetchQuotationData();
    }, []);

    function fetchQuotationData() {
        axios
            .get(`${baseUrl}pharm-vendor-quotation/`)
            .then(async (response) => {

                const itemResponse = await axios.get(
                    `${baseUrl}pharm-vendor-quotation-item/`
                );

                const items = itemResponse.data;

                const transformed = response.data.map((item) => {

                    const rowItems = items.filter(
                        x => x.quotation?.id === item.id
                    );

                    return {
                        id: item.id,
                        rfq_id: item.rfq?.id,
                        quotation_no: item.quotation_no,
                        quotation_date: item.quotation_date,
                        vendor: item.vendor?.name,
                        total_amount: item.total_amount,

                        products: rowItems.map(x => x.product).join(", "),
                    };
                });

                setQuotationData(transformed);
            })
            .catch(console.log);
    }

    const toggleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]
        );
    };

    const goCompare = () => {
        if (selectedIds.length < 2) {
            alert("Select at least 2 quotations");
            return;
        }

        navigate(`/pharm-quotation-compare?ids=${selectedIds.join(",")}`);
    };

    const columns = [
        {
            field: "select",
            headerName: "Select",
            width: 100,
            renderCell: (params) => (
                <input
                    type="checkbox"
                    checked={selectedIds.includes(params.row.id)}
                    onChange={() => toggleSelect(params.row.id)}
                />
            )
        },
        { field: "id", headerName: "ID", width: 80 },
        { field: "quotation_no", headerName: "Quotation No", width: 160 },
        { field: "vendor", headerName: "Vendor", width: 200 },
        { field: "products", headerName: "Products", width: 350 },
        { field: "total_amount", headerName: "Total Amount", width: 150 },

        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => (
                <div className="d-flex gap-2">
                    <Link
                        to={`/pharm-vendor-quotation-view/${params.row.id}`}
                        className="btn btn-success btn-sm"
                    >
                        View
                    </Link>
                </div>
            )
        }
    ];

    return (
        <section className="container-fluid mt-3">

            <h3 className="text-center mb-3">
                Vendor Quotations
            </h3>

            <button
                className="btn btn-primary mb-3"
                onClick={goCompare}
            >
                Compare Selected
            </button>

            <DataGrid
              sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
                rows={quotationData}
                columns={columns}
                pageSize={10}
                autoHeight
                slots={{ toolbar: GridToolbar }}
            />
        </section>
    );
}

export default PharmVendorQuoteList;